import {
  ProfilePicure,
  HTMLIcon,
  CSSIcon,
  SassIcon,
  BootstrapIcon,
  JavaScriptIcon,
  JqueryIcon,
  ReactIcon,
  ReduxIcon,
  TypescriptIcon,
  GitIcon,
  VSCodeIcon,
  CanvaIcon,
  blog1Icon,
  blog2Icon,
  coercion,
  Instagram,
  LinkedIn,
  Twitter,
  Github,
} from "./link-repo";

// Database
export const profileData = {
  GeneralInfo: {
    name: "Shahbaz Khan",
    designation: "Frontend Engineer",
    profilePicture: ProfilePicure,
    about:
      "I started my career as a full-stack developer and worked on multiple web applications for a US-based media and communication company where I learned a lot about end-to-end web development including requirement gathering, UI design, frontend & backend development, database design & implementation, product deployment, communication, and much more. With an inclination toward UI/UX and JavaScript, I decided to have a specialization in Frontend development so that I could build scalable and sophisticated UI/UX with accessibility, SEO and web performance. Currently, I am working as a Frontend Engineer and building a fintech application that is being used by millions of users across the globe.\n I enjoy teaching and helping others learn about web development and share technical conten on instagram and LinkedIn",
  },
  Skills: [
    {
      id: 1,
      name: "HTML",
      icon: HTMLIcon,
    },
    {
      id: 2,
      name: "CSS",
      icon: CSSIcon,
    },
    {
      id: 3,
      name: "Sass",
      icon: SassIcon,
    },
    {
      id: 4,
      name: "Bootstrap",
      icon: BootstrapIcon,
    },
    {
      id: 5,
      name: "JavaScript",
      icon: JavaScriptIcon,
    },
    {
      id: 6,
      name: "JQuery",
      icon: JqueryIcon,
    },
    {
      id: 7,
      name: "React",
      icon: ReactIcon,
    },
    {
      id: 8,
      name: "Redux",
      icon: ReduxIcon,
    },
    {
      id: 9,
      name: "TypeScript",
      icon: TypescriptIcon,
    },
    {
      id: 10,
      name: "Git",
      icon: GitIcon,
    },
    {
      id: 11,
      name: "VSCode",
      icon: VSCodeIcon,
    },
    {
      id: 12,
      name: "Canva",
      icon: CanvaIcon,
    },
  ],
  Projects: [
    {
      id: 1,
      title: "Text to Speech Bot",
      description: "A web application that converts your text to speech",
      URL: "https://shahbaz4595.github.io/text2speech/",
      sourceCode: "https://github.com/shahbaz4595/text2speech",
      techStack: "html, css, javascript,",
    },
    {
      id: 2,
      title: "Task Manager",
      description: "A web based task manager that helps you manage your tasks",
      URL: "https://shahbaz4595.github.io/task-manager/",
      sourceCode: "https://github.com/shahbaz4595/task-manager",
      techStack: "React JS, React Hooks",
    },
    {
      id: 3,
      title: "URL Shortener",
      description: "A web application that helps you shorten your long URLs",
      URL: "https://shahbaz4595.github.io/url-shortener/",
      sourceCode: "https://github.com/shahbaz4595/url-shortener",
      techStack: "React JS, React Hooks",
    },
    {
      id: 4,
      title: "BleedBlue CSS",
      description: "UI component library for building responsive interfaces.",
      URL: "https://bleedblue.netlify.app/",
      sourceCode: "https://github.com/shahbaz4595/BleedBlue-CSS",
      techStack: "HTML, CSS",
    },
  ],

  Blogs: [
    {
      id: 1,
      title: "Functional Programming in JavaScript",
      description:
        "Functional programming is a programming paradigm where functions are the main building blocks of any program and logics are written inside the functions.",
      URL: "https://blog.shahbazkhan.in/introduction-to-functional-programming-in-javascript",
      photo: blog2Icon,
    },
    {
      id: 2,
      title:
        "Do you really think that loose equals (==) compares the value and strict equals (===) compares the value as well as the type of two variables in JS?",
      description:
        "If you think that loose equals (==) compares the value and strict equals (===) compares the value as well as type of two variables, let me give you a surprise :)",
      URL: "https://blog.shahbazkhan.in/do-you-really-think-that-loose-equals-compares-the-value-and-strict-equals-compares-the-value-as-well-as-the-type-of-two-variables-in-js",
      photo: coercion,
    },
    {
      id: 3,
      title: "Promise in JavaScript simplified!",
      description:
        "Promise in JavaScript is just like a promise in real life. It enables us to perform asynchronous tasks in JavaScript and always returns a result whether the promise is fulfilled or not.",
      URL: "https://blog.shahbazkhan.in/promise-in-javascript-simplified",
      photo: blog1Icon,
    },
  ],
  SocialMedia: [
    {
      id: 1,
      platform: "LinkedIn",
      icon: LinkedIn,
      URL: "https://www.linkedin.com/in/shahbaz-khan4595/",
    },
    {
      id: 2,
      platform: "Instagram",
      icon: Instagram,
      URL: "https://www.instagram.com/shahbazkhan.js/",
    },
    {
      id: 3,
      platform: "Twitter",
      icon: Twitter,
      URL: "https://twitter.com/shahbazkhan_js",
    },
    {
      id: 4,
      platform: "Github",
      icon: Github,
      URL: "https://github.com/shahbaz4595",
    },
  ],
};
